import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { ToastGuidSetting } from '../types/toastGuidSetting';

type ToastGuidSettingsResponse = {
  data: ToastGuidSetting[];
  meta?: {
    total: number;
  };
};

type DefaultError = unknown;

export const toastGuidSettingQueryKeys = {
  all: ['toastGuidSettings'] as const,
  lists: () => [...toastGuidSettingQueryKeys.all, 'list'] as const,
  list: (params: Record<string, string>) =>
    [...toastGuidSettingQueryKeys.lists(), params] as const,
};

type UseToastGuidSettingsParams = {
  searchParams?: Record<string, string>;
  enabled?: boolean;
};

export function useToastGuidSettings<
  TData = ToastGuidSettingsResponse,
  TError = DefaultError,
>(
  { searchParams = {}, enabled = true }: UseToastGuidSettingsParams = {},
  options?: Omit<
    UseQueryOptions<ToastGuidSettingsResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = toastGuidSettingQueryKeys.list(searchParams);

  return useQuery<ToastGuidSettingsResponse, TError, TData>({
    queryKey,
    enabled,
    queryFn: async () => service.getToastGuidSettings(searchParams),
    ...(options as any),
  });
}
